module.exports = __webpack_public_path__ + "static/media/demo_v2.a003d53c.mp4";